import { RIGHTS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"


export const update = ({ commit },data) => {
    const url = `${RIGHTS_API}/${data.id ?? 0}`
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_NOT_UPDATED)

    backend({ url, data, method: "PUT" }).then(({ data }) => {
        commit(types.SET_UPDATE, data.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE,data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, data)
        commit(types.SET_IS_UPDATED)
    }).catch((err) => {
        commit(types.SET_UPDATE, null)

        commit(types.SET_NOT_UPDATED)
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.data?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}


export const resetData = ({ commit }) => {
    commit(types.RESET)
}



